import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { isAndroid } from 'react-device-detect';

import { forms as Forms, pills as Pills } from '@breezeway/brzw-components';

import './form_control_native_select.scss';
import ModalSelect from '../../../modal_select';

class FormControlNativeMultiselect extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      openModal: false,
    };

    this.closeModalSelect = this.closeModalSelect.bind(this);
    this.focusNativeSelect = this.focusNativeSelect.bind(this);
    this.onModalSelect = this.onModalSelect.bind(this);
    this.onRemovePills = this.onRemovePills.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.openModalSelect = this.openModalSelect.bind(this);
  }

  onSelect(code) {
    if (!code) {
      return;
    }
    const {
      input: { value, onChange },
      options,
      selectValue,
    } = this.props;

    const option = _.find(options, { value: code });

    if (selectValue) {
      onChange([...value, option.value]);
    } else {
      onChange([...value, { code: option.value, name: option.label }]);
    }
  }

  onRemovePills(index) {
    const {
      input: { value, onChange },
    } = this.props;

    onChange([..._.slice(value, 0, index), ..._.slice(value, index + 1)]);
  }

  onModalSelect(option) {
    const {
      input: { value, onChange },
      selectValue,
    } = this.props;

    if (selectValue) {
      onChange([...value, option.value]);
    } else {
      onChange([...value, { code: option.value, name: option.label }]);
    }
  }

  closeModalSelect() {
    this.setState({ openModal: false });
  }

  openModalSelect() {
    this.setState({ openModal: true });
  }

  focusNativeSelect() {
    this.nativeSelect.focus();
  }

  render() {
    const {
      className,
      id,
      input: { value },
      label,
      meta: { error },
      onlyModal,
      options,
      placeholder,
      required,
      selectValue,
    } = this.props;

    const filteredOptions = _.filter(options, option => {
      if (selectValue) {
        return !_.includes(value, option.value);
      } else {
        return !_.includes(_.map(value, 'code'), option.value);
      }
    });

    const nativeOptions = [{ label: '', value: null }, ...filteredOptions];

    return (
      <Fragment>
        <div
          role="presentation"
          onClick={isAndroid || onlyModal ? this.openModalSelect : this.focusNativeSelect}
        >
          <Forms.Select
            className={className}
            id={id}
            isRequired={required}
            labelText={label}
            options={filteredOptions}
            placeholderText={placeholder}
            value={value}
            withError={error}
            shouldOpenModal
            withNativeSelect
          />
        </div>
        {!isAndroid && !onlyModal && (
          <select
            className="form-control-native-select__select"
            ref={selectRef => {
              this.nativeSelect = selectRef;
            }}
            onChange={e => this.onSelect(e.target.value)}
          >
            {nativeOptions.map(option => (
              <option key={option.value} value={option.value} name={option.label}>
                {option.label}
              </option>
            ))}
            ;
          </select>
        )}
        {this.state.openModal && (
          <ModalSelect
            full
            onClose={this.closeModalSelect}
            onSelect={this.onModalSelect}
            options={filteredOptions}
            title={label}
          />
        )}
        <div className="multiselect__pills-wrapper">
          {_.map(value, (element, index) => {
            const pillName = _.get(_.find(options, { value: element }), 'label');
            return (
              <div
                className="multiselect__pill-wrapper"
                key={`additional-element-wrapper-${index}`}
              >
                <Pills.Pill
                  key={`multiselect-element-${index}`}
                  onClick={() => this.onRemovePills(index)}
                  text={selectValue ? pillName : element.name}
                />
              </div>
            );
          })}
        </div>
      </Fragment>
    );
  }
}

FormControlNativeMultiselect.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  input: PropTypes.shape({}),
  label: PropTypes.string,
  meta: PropTypes.shape({}),
  onlyModal: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.shape({})),
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  selectValue: PropTypes.bool,
};

FormControlNativeMultiselect.defaultProps = {
  className: '',
  options: [],
  selectValue: false,
};

export default FormControlNativeMultiselect;
